import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import ru from './ru'

Vue.use(VueI18n)

const messages = {
  en,
  ru,
}

// VueI18n instance
const i18n = new VueI18n({
  locale: 'ru',
  fallbackLocale: 'ru',
  messages,
  numberFormats: {
    en: {
      currency: {
        style: 'currency',
        currency: 'USD',
      },
    },
    ru: {
      currency: {
        style: 'currency',
        currency: 'RUB',
        currencyDisplay: 'symbol',
      },
    },
  },
  pluralizationRules: {
    ru: function(choice) {
      if (choice === 0) {
        return 0
      }
      const teen = choice > 10 && choice < 20
      const endsWithOne = choice % 10 === 1

      if (!teen && endsWithOne) {
        return 1
      }
      if (!teen && choice % 10 >= 2 && choice % 10 <= 4) {
        return 2
      }
      return 3
    },
  },
})

export { i18n }
// Hot reload
// if (module.hot) {
//   module.hot.accept(['./en', './ru'], () => {
//     i18n.setLocaleMessage('en', require('./en').default)
//     i18n.setLocaleMessage('ru', require('./ru').default)
//     // Or the following hot updates via $i18n property
//     // app.$i18n.setLocaleMessage('en', require('./en').default)
//     // app.$i18n.setLocaleMessage('ja', require('./ja').default)
//   })
// }
